export default {
  "register.index.title": "イベント投稿アカウント新規登録 | LINK-J",
  "register.index.description":
    "LINK-J（一般社団法人ライフサイエンス・イノベーション・ネットワーク・ジャパン）は、再生医療・個別化医療・創薬・医療機器・ヘルスケアITをはじめ、予防・未病・健康長寿など広義のライフサイエンス分野にかかわる世界の人々や情報が交流できるようなプラットフォームを構築し、イノベーション創出のためのエコシステムを創ります。",
  "register.index.ogSiteName": "LINK-J",
  "register.index.ogTitle":
    "一般社団法人　ライフサイエンス・イノベーション・ネットワーク・ジャパン（LINK-J）",
  "register.index.ogDescription":
    "「日本橋」×「ライフサイエンス」。人と情報の交流プラットフォーム、そしてライフサイエンスの新産業創造。セミナー・勉強会やマッチングイベントなど交流機会の提供。コミュニケーションラウンジや会議室など交流の場の提供。",
  "register.index.pagetitle.newAccount": "投稿アカウント新規登録",
  "register.index.lead":
    "LINK-J特別会員用投稿アカウントの新規登録ページです。下記の同意事項をお読みいただき、ご同意いただける場合は下の「同意する」ボタンをクリックして、登録フォームへとお進みください。",
  "register.index.agreement.title": "同意事項",
  "register.index.agreement.text1_01":
    "1．お客様からご提供いただく個人情報は、当法人「",
  "register.index.agreement.privacy.link.text": "個人情報保護に関する基本方針",
  "register.index.agreement.text1_02": "」および「",
  "register.index.agreement.use.link.text": "個人情報の利用目的",
  "register.index.agreement.text1_03": "」に基づき管理いたします。",
  "register.index.agreement.text2_01":
    "2．当法人がお問い合わせフォームで取得した、お客様の個人情報は、お客様への回答の目的のみに使用いたしますが、お問い合わせ内容により、当方人の提携先である三井不動産株式会社、三井不動産ビルマネジメント株式会社で対応させていただく場合がございます。",
  "register.index.agreement.text2_02":
    "その場合、提携先に、お客様の個人情報を、提供することがございますので、あらかじめご了承ください。",
  "register.index.agreement.text3":
    "3．当法人がお客様へ回答する内容の一部または全部を、お客様が転載、二次利用することはできません。",
  "register.index.agreement.text4":
    "4．土日祝日にいただいたお問い合わせについては、翌営業日以降の回答となりますので、あらかじめご了承ください。",
  "register.index.agreement.text5":
    "5．商品・サービス等の営業に関するお問い合わせについては返信いたしかねますのでご了承ください。",
  "register.index.button.agree": "同意する",
  "register.index.button.disagree": "同意しない",

  "register.form.title": "イベント投稿アカウント新規登録 | LINK-J",
  "register.form.description":
    "LINK-J（一般社団法人ライフサイエンス・イノベーション・ネットワーク・ジャパン）は、再生医療・個別化医療・創薬・医療機器・ヘルスケアITをはじめ、予防・未病・健康長寿など広義のライフサイエンス分野にかかわる世界の人々や情報が交流できるようなプラットフォームを構築し、イノベーション創出のためのエコシステムを創ります。",
  "register.form.ogSiteName": "LINK-J",
  "register.form.ogTitle":
    "一般社団法人　ライフサイエンス・イノベーション・ネットワーク・ジャパン（LINK-J）",
  "register.form.ogDescription":
    "「日本橋」×「ライフサイエンス」。人と情報の交流プラットフォーム、そしてライフサイエンスの新産業創造。セミナー・勉強会やマッチングイベントなど交流機会の提供。コミュニケーションラウンジや会議室など交流の場の提供。",
  "register.form.pagetitle.newAccount": "投稿アカウント新規登録",
  "register.form.pagecontent.head": "お客様の情報入力",
  "register.form.register.formTitle": "アカウント登録フォーム",

  "form_check.index.title": "イベント投稿アカウント新規登録 | LINK-J",
  "form_check.index.description":
    "LINK-J（一般社団法人ライフサイエンス・イノベーション・ネットワーク・ジャパン）は、再生医療・個別化医療・創薬・医療機器・ヘルスケアITをはじめ、予防・未病・健康長寿など広義のライフサイエンス分野にかかわる世界の人々や情報が交流できるようなプラットフォームを構築し、イノベーション創出のためのエコシステムを創ります。",
  "form_check.index.ogSiteName": "LINK-J",
  "form_check.index.ogTitle":
    "一般社団法人　ライフサイエンス・イノベーション・ネットワーク・ジャパン（LINK-J）",
  "form_check.index.ogDescription":
    "「日本橋」×「ライフサイエンス」。人と情報の交流プラットフォーム、そしてライフサイエンスの新産業創造。セミナー・勉強会やマッチングイベントなど交流機会の提供。コミュニケーションラウンジや会議室など交流の場の提供。",
  "form_check.pagetitle.newAccount": "投稿アカウント新規登録",
  "form_check.pagecontent.head": "お客様の情報入力",
  "form_check.register.formTitle": "アカウント登録フォーム",
  "form_check.register.confirmMsg":
    "以上の内容で送信します。ご確認のうえ、「この内容で送信する」ボタンを押してください。",
  "form_check.register.noscriptMsg":
    "修正する場合は、ブラウザの戻るボタンで戻ってください。",
  "form_check.register.backBtn": "戻る",
  "form_check.register.submitBtn": "この内容で送信する",
  "form_check.register.labels.nameKanji": "氏名（漢字）",
  "form_check.register.labels.nameKana": "氏名（フリガナ）",
  "form_check.register.labels.organization": "企業・団体名",
  "form_check.register.labels.organizationKana": "企業・団体名（フリガナ）",
  "form_check.register.labels.department": "所属部署名",
  "form_check.register.labels.email": "メールアドレス",
  "form_check.register.labels.loginId": "希望ユーザー名",
  "form_check.register.labels.loginIdNote": "（半角英数字、半角記号）",
  "form_check.register.labels.loginPwd": "希望パスワード",
  "form_check.register.labels.loginPwdNote": "（半角英数字、半角記号）",
  "form_check.required": "必須",
  "form.register.nameKanji": "氏名（漢字）",
  "form.register.required": "必須",
  "form.register.name1Label": "姓",
  "form.register.name2Label": "名",
  "form.register.name1Error": "氏名（漢字）(姓)を入力してください",
  "form.register.name2Error": "氏名（漢字）(名)を入力してください",
  "form.register.nameKana": "氏名（フリガナ）",
  "form.register.name1KanaLabel": "セイ(カタカナ)",
  "form.register.name2KanaLabel": "メイ(カタカナ)",
  "form.register.name1KanaError":
    "氏名（フリガナ）(セイ)をカタカナで入力してください",
  "form.register.name2KanaError":
    "氏名（フリガナ）(メイ)をカタカナで入力してください",
  "form.register.organization": "企業・団体名",
  "form.register.organizationError": "企業・団体名を入力してください",
  "form.register.organizationKana": "企業・団体名（フリガナ）",
  "form.register.organizationKanaError":
    "企業・団体名（フリガナ）を入力してください",
  "form.register.department": "所属部署名",
  "form.register.departmentError": "所属部署名を入力してください",
  "form.register.email": "メールアドレス",
  "form.register.emailError":
    "メールアドレス(英数記号のみ)を入力してください 例）foo@example.com",
  "form.register.emailConfirmLabel": "確認のためもう一度入力してください",
  "form.register.emailConfirmError": "同じ値を入力してください",
  "form.register.loginId": "希望ユーザー名",
  "form.register.loginIdNote": "（半角英数字50文字以内）",
  "form.register.loginIdError": "希望ユーザー名を正しく入力してください",
  "form.register.apiError": "入力エラー:すでに登録済みのユーザー名です",
  "form.register.loginPwd": "希望パスワード",
  "form.register.loginPwdNote": "（半角英数字10桁以上 大文字記号含む）",
  "form.register.loginPwdError": "希望パスワードを正しく入力してください",
  "form.register.usernameError": "パスワードにユーザー名を含むことはできません",
  "form.register.submitBtn": "確認",
  "form.register.inputErrorPrefix": "Input error",

  "complete.index.title": "イベント投稿アカウント新規登録 | LINK-J",
  "complete.index.description":
    "LINK-J（一般社団法人ライフサイエンス・イノベーション・ネットワーク・ジャパン）は、再生医療・個別化医療・創薬・医療機器・ヘルスケアITをはじめ、予防・未病・健康長寿など広義のライフサイエンス分野にかかわる世界の人々や情報が交流できるようなプラットフォームを構築し、イノベーション創出のためのエコシステムを創ります。",
  "complete.index.ogSiteName": "LINK-J",
  "complete.index.ogTitle":
    "一般社団法人　ライフサイエンス・イノベーション・ネットワーク・ジャパン（LINK-J）",
  "complete.index.ogDescription":
    "「日本橋」×「ライフサイエンス」。人と情報の交流プラットフォーム、そしてライフサイエンスの新産業創造。セミナー・勉強会やマッチングイベントなど交流機会の提供。コミュニケーションラウンジや会議室など交流の場の提供。",
  "complete.pagetitle.newAccount": "投稿アカウント新規登録",
  "complete.sendCompletely": "送信完了",
  "complete.completeText.line1": "仮登録していただき、ありがとうございます。",
  "complete.completeText.line2":
    "内容を確認後、運営事務局より数日以内にメールにてご連絡いたします。",
  "complete.completeText.line3": "なお、1週間を経過しても連絡がない場合は、",
  "complete.completeText.line4":
    "送信トラブルなどによりメールフォームからの仮登録が不着となっている可能性がございます。",
  "complete.completeText.line5":
    "その場合は、大変お手数ですが下記にてご連絡いただきますようお願いいたします。",
  "complete.contactLink": "お問い合わせはこちら",
  "complete.topLink": "TOPへ戻る",
} as const;
